import React, {FC} from 'react';

import download from 'assets/v3/guide/image/download.webp';
import engineConfig from 'assets/v3/guide/image/engine-config.webp';
import refine from 'assets/v3/guide/image/refine.webp';
import refineDone from 'assets/v3/guide/image/refine-done.webp';
import result from 'assets/v3/guide/image/result.webp';
import translating from 'assets/v3/guide/image/translating.webp';
import uploadEcommerce1 from 'assets/v3/guide/image/upload-ecommerce-1.webp';
import uploadEcommerce2 from 'assets/v3/guide/image/upload-ecommerce-2.webp';
import uploadLink from 'assets/v3/guide/image/upload-link.webp';
import uploadLocal from 'assets/v3/guide/image/upload-local.webp';

/** 使用指南「图片翻译」tab 中文正文。2026-09-17 按业务最新版《象寄图片翻译使用指南》
 * （docx）重写：上传前介绍（含翻译引擎对比表）+ 三种图片上传 + 翻译 + 精修 + 下载。 */
const ZhContent: FC = () => {
  return (
    <>
      <h2>1. 上传前介绍</h2>
      <p>图片上传前按需选择版本、源语言和目标语言。</p>
      <img alt="翻译配置：版本/源语言/目标语言" decoding="async" loading="lazy" src={engineConfig} />
      <p>
        <strong>源语言</strong>：原图文字是什么语言，就选择什么语言。
      </p>
      <p>
        <strong>目标语言</strong>：需要翻译的不同国家语言。
      </p>

      <h3>翻译引擎如何选择？</h3>
      <div className="v3-table-wrap">
        <table>
          <thead>
            <tr>
              <th>引擎</th>
              <th>优势</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>阿里云/百度</td>
              <td>中文表达比较地道，更适合【外语翻译中文】；中文翻译外语的表现上略逊色，价格较便宜</td>
            </tr>
            <tr>
              <td>Google</td>
              <td>更适用于外语翻译，适用语种广泛</td>
            </tr>
            <tr>
              <td>Papago</td>
              <td>韩国云服务商 naver 的产品，外语翻译韩语比较地道</td>
            </tr>
            <tr>
              <td>DeepL</td>
              <td>更适用于外语翻译，适用语种广泛，如日语、英语、德语、俄语等，在俚语、方言、文言文等方面表现优异</td>
            </tr>
            <tr>
              <td>ChatGPT</td>
              <td>目前最好的自然语言模型，文本翻译地道准确</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>2. 图片上传</h2>
      <h3>本地图片上传</h3>
      <p>点击上传按钮，浏览本地文件，按需选择产品图片上传。</p>
      <img alt="本地图片上传" decoding="async" loading="lazy" src={uploadLocal} />

      <h3>输入图片链接</h3>
      <p>切换到输入图片链接，可批量导入需要翻译的图片链接。</p>
      <img alt="输入图片链接" decoding="async" loading="lazy" src={uploadLink} />

      <h3>粘贴电商链接</h3>
      <p>将产品链接粘贴进去，即可采集此产品链接图片，按需选择进行翻译。</p>
      <img alt="粘贴电商链接" decoding="async" loading="lazy" src={uploadEcommerce1} />
      <img alt="采集到的商品图片" decoding="async" loading="lazy" src={uploadEcommerce2} />

      <h2>3. 图片翻译</h2>
      <p>上传图片后点击【立即翻译】按钮，AI 自动开始翻译。</p>
      <img alt="开始图片翻译" decoding="async" loading="lazy" src={translating} />
      <p>
        AI 图片翻译处理时间在 2~3
        秒左右即可处理完成。翻译完成后可以原图译图对比查看效果，满意可按需直接点击【下载全部】或【复制译后图片链接】；不满意译后图片或者需要重新排版，点击【去精修】进入精修工具调整图片。
      </p>
      <img alt="原图与译图对比" decoding="async" loading="lazy" src={result} />

      <h2>4. 图片精修</h2>
      <p>点击【去精修】打开精修工作台，点击需要编辑的文本。</p>
      <ul>
        <li>
          <strong>文本编辑区</strong>：原文本的修改二次翻译；文本样式、角度、描边等调整。
        </li>
        <li>
          <strong>修复工具</strong>：可添加文字进行翻译，使用智能消除笔擦除瑕疵或修复瑕疵等。
        </li>
      </ul>
      <img alt="精修工作台" decoding="async" loading="lazy" src={refine} />
      <p>精修完成后点击【完成编辑】保存修改结果，退出精修工具。</p>
      <img alt="完成精修" decoding="async" loading="lazy" src={refineDone} />

      <h2>5. 下载</h2>
      <p>点击【下载全部】或【复制图片链接】，精修图会自动替代未精修图进行下载导出。</p>
      <img alt="下载译后图片" decoding="async" loading="lazy" src={download} />
    </>
  );
};

export default ZhContent;
